module.exports = __webpack_public_path__ + "1d05450af7d6820bd843f05807a1c54f.pdf";